import { Check, Sparkles } from "lucide-react";
import type { AIStyle } from "@fiket/booth-schema";
import type { Language } from "../../store/router";
import { styleName, styleDescription } from "../../hooks/useStyles";
import { useBoothVideoEnabled } from "../../store/booth";

interface Props {
  style: AIStyle;
  active: boolean;
  language: Language;
  onSelect: () => void;
}

/**
 * 스타일 타일 (HERIT 260×340) — 라운드 14 썸네일 + 이름(22/500) · 설명(16/300, 2줄).
 * 선택 시 3px 그린 테두리 + 우상단 44px 그린 원에 흰 체크. 영상 지원 스타일은 스파클 배지.
 */
export function StyleCard({ style, active, language, onSelect }: Props) {
  const name = styleName(style, language);
  const desc = styleDescription(style, language);
  const boothVideoEnabled = useBoothVideoEnabled();
  return (
    <li>
      <button
        type="button"
        className="tile"
        data-style-id={style.id}
        role="option"
        aria-selected={active}
        aria-pressed={active}
        aria-label={name}
        onClick={onSelect}
      >
        <div className="tile__img">
          {style.thumbnailUrl ? <img src={style.thumbnailUrl} alt="" draggable={false} /> : null}
          {active ? (
            <span className="tile__check" aria-hidden><Check size={22} strokeWidth={2.4} /></span>
          ) : boothVideoEnabled && style.videoEnabled ? (
            <span className="tile__spark" aria-hidden><Sparkles size={22} strokeWidth={1.8} /></span>
          ) : null}
        </div>
        <strong>{name}</strong>
        {desc ? <p>{desc}</p> : null}
      </button>
    </li>
  );
}
